import React from 'react';

class Contact extends React.Component {

    handleClick(type) {
        window.gtag('event', 'melde feil', {
            'event_category': 'click',
            'event_label': type
        });
    }


    render() {

        if ((this.props.loan.financialInstitutionEmail !== undefined) && (this.props.loan.financialInstitutionEmail.trim() !== "")) {
            var email = this.props.loan.financialInstitutionEmail.trim();
            var subject = "Melding om lån/kreditt registrert i Gjeldsregisteret";
            var body = "Avsender har innhentet oversikt over egne lån registrert hos Gjeldsregisteret AS, og ønsker å informere dere som låne-/kredittyter om følgende:";
            var mailto = "mailto:" + email + "?subject=" + subject + "&body=" + body;
            return <div class='contact'>
                <a id ="mailto" href={mailto} onClick={()=>{this.handleClick('epost')}}><i className="far fa-envelope"></i> Melde feil</a>
            </div>
        }
        else if ((this.props.loan.financialInstitutionPhone !== undefined) && (this.props.loan.financialInstitutionPhone.trim() !== "")) {
            var phone = this.props.loan.financialInstitutionPhone.trim();
            var tel = "tel:" + phone;
            return <div class='contact'>
                <a id ="tel" href={tel} onClick={()=>{this.handleClick('telefon')}}><i className="fas fa-phone"></i> {phone}</a>
            </div>
        }
        else if ((this.props.loan.financialInstitutionUrl !== undefined) && (this.props.loan.financialInstitutionUrl.trim() !== "")) {
            var url = this.props.loan.financialInstitutionUrl.trim();
            return <div class='contact'>
                <a id ="url" href={url} target="_blank" rel="noopener noreferrer" onClick={()=>{this.handleClick('hjemmeside')}}><i className="fas fa-globe"></i> Hjemmeside</a>
            </div>
        }
        else {
            return <div class='none'>
                Se bank
            </div>
        }

    }
}

export default Contact;

